import { render, staticRenderFns } from "./sharePage.vue?vue&type=template&id=c5cae45e&scoped=true&"
import script from "./sharePage.vue?vue&type=script&lang=js&"
export * from "./sharePage.vue?vue&type=script&lang=js&"
import style0 from "./sharePage.vue?vue&type=style&index=0&id=c5cae45e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cae45e",
  null
  
)

export default component.exports